<div [formGroup]="form" class="flex flex-column gap-2">
  <label [attr.for]="item.key" class="font-semibold"
    >{{ item.label || '' | translate }}
    <span class="asterisk" *ngIf="item.required">*</span>
  </label>
  <div class="flex gap-2" [ngClass]="{ 'flex-column': direction === 'column' }">
    <div
      class="field-radiobutton"
      *ngFor="let option of item.options || []; let i = index"
    >
      <p-radioButton
        ngClass="{{ isInValid ? 'ng-invalid ng-dirty' : '' }}"
        [formControlName]="item.key"
        [name]="item.key"
        [value]="option.value"
        inputId="binary"
      >
      </p-radioButton>
      <label [for]="item.key">{{ option.label }}</label>
    </div>
  </div>

  <small
    class="p-error block font-italic"
    *ngIf="isInValid && hasError('required')"
  >
    {{
      item.errorMessage?.required?.message || ''
        | translate : item.errorMessage?.required?.params
    }}
  </small>
</div>
